module.exports = __webpack_public_path__ + "img/img4_6.a25ea163.jpeg";